// "Nästa: 1 juli" a week later is a broken promise, not today's work, and has
// to read as one (YCRM-59). Days are Stockholm calendar days, the same day
// boundary the server bands the queue by, so a promise for yesterday evening
// is one day late at 00:30 whatever the browser's timezone.

const STOCKHOLM_DATE = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Stockholm', year: 'numeric', month: 'numeric', day: 'numeric',
})

function stockholmDayNumber(ms: number): number {
  const part = (type: string) =>
    Number(STOCKHOLM_DATE.formatToParts(ms).find(p => p.type === type)?.value)
  return Date.UTC(part('year'), part('month') - 1, part('day')) / 86_400_000
}

/** Stockholm calendar days a promised next contact is past; 0 when it is
 *  today, later, missing or unreadable. */
export function daysOverdue(nextContactAt: string | null | undefined, now: number): number {
  const at = nextContactAt ? Date.parse(nextContactAt) : NaN
  if (Number.isNaN(at)) return 0
  return Math.max(0, stockholmDayNumber(now) - stockholmDayNumber(at))
}

export function overdueLabel(days: number): string {
  return `försenad ${days} ${days === 1 ? 'dag' : 'dagar'}`
}
